var baseStyle = {
  opacity: 0.6,
  borderColor: "inherit"
};
var variantSolid = {
  borderStyle: "solid"
};
var variantDashed = {
  borderStyle: "dashed"
};
var variants = {
  solid: variantSolid,
  dashed: variantDashed
};
var defaultProps = {
  variant: "solid"
};
export default {
  baseStyle,
  variants,
  defaultProps
};
//# sourceMappingURL=divider.js.map